const lenis = new Lenis()


lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time)=>{
  lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)


// product buy-buttons animation
// document.addEventListener('DOMContentLoaded', function() {
//     var mobileHeader = document.getElementById('mobile-header');
//     var productFormButtons = document.querySelector('.product-form__buttons');

//     if (productFormButtons) {
//         mobileHeader.classList.add('hidden');
//     }
// });

// window.addEventListener('scroll', function() {
//     if (window.scrollY >= 50) {
//       document.querySelector('.product-form__buttons').classList.add('relative');
//       document.querySelector('.mobile-header').classList.remove('hidden');
//     } else {
//       document.querySelector('.product-form__buttons').classList.remove('relative');
//       document.querySelector('.mobile-header').classList.add('hidden');
//     }
//   });
// 

// -------- new added js --------

document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 950) { // Check if the viewport is mobile-sized
        var mobileHeader = document.getElementById('mobile-header');
        var productFormButtons = document.querySelector('.product-form__buttons');

        if (productFormButtons) {
            mobileHeader.classList.add('hidden');
        }

        window.addEventListener('scroll', function() {
            if (window.scrollY >= 50) {
                productFormButtons.classList.add('relative');
                mobileHeader.classList.remove('hidden');
            } else {
                productFormButtons.classList.remove('relative');
                mobileHeader.classList.add('hidden');
            }
        });
    }
});

// ---------



// hero-section text-animation
let heroTextAnimation = gsap.timeline({ repeat: -1, ease: "power4.inOut" });

let targets = document.querySelectorAll(".words span");
let numberOfTargets = targets.length;
let duration = 0.8; //change this
let pause = 3; // change this
let stagger = duration + pause;
let repeatDelay = stagger * (numberOfTargets - 1) + pause;

function init() {
  gsap.set(".words", { autoAlpha: 1 });
  heroTextAnimation
    .from(targets, {
      y: 80,
      duration: duration,
      opacity: 0,
      rotationX: -50, // Rotate around the X-axis for the 3D flip effect
      transformOrigin: "bottom center", // Set the transform origin to bottom center
      stagger: {
        each: stagger,
        repeat: -1,
        repeatDelay: repeatDelay
      }
    })
    .to(
      targets,
      {
        y: -50,
        duration: duration,
        opacity: 0,
        rotationX: 0, // Rotate around the X-axis back to 0 for the flip animation
        transformOrigin: "top center", // Set the transform origin to top center
        stagger: {
          each: stagger,
          repeat: -1,
          repeatDelay: repeatDelay
        }
      },
      stagger
    );
}

init();







// -------------customised animation-------------------
let isScrollAllowed3 = true;
let tmln3;

function initTimeline() {
    gsap.to('.sorta_banner_title .h1-original', {
        scrollTrigger: {
            trigger: ".sorta_banner_title",
            start: "top 82%",
            end: "top 40%",
            scrub: 0.3,
          // duration : 4,
            // toggleActions: 'play play reverse reverse',
        },
        clipPath: "inset(0 0% 0% 0)"
    });

    tmln3 = gsap.timeline({
        scrollTrigger: {
            trigger: ".sorta_banner_title",
            start: "top 74%",
            end: "top 17%",
            scrub: 0.7,
            toggleActions: 'play play reverse reverse',
        }
    });
    tmln3.to(".sorta_banner_title h1", {
        x: -740,
        pin : true,
      
    });
}

function checkScreenWidth() {
    if (window.innerWidth <= 950 || document.documentElement.clientWidth <= 950) {
        initTimeline(); 
    } else {
        
        gsap.to('.sorta_banner_title .h1-original', {
            scrollTrigger: {
                trigger: ".sorta_banner_title",
                start: "top 85%",
                end: "bottom center",
                scrub: 0.5,
                // markers : true,
                toggleActions: 'play play reverse reverse',
            },
            clipPath: "inset(0 0% 0% 0)",
            delay: 1    
        });
    }
}

checkScreenWidth();





// mobile menu toggles
function toggleMenu12() {
    const bgBlur = document.querySelector('.blur-bg');
    bgBlur.classList.toggle('blur-open');
    var toggleElem = document.querySelector('.toggle12');
    toggleElem.classList.toggle('open');

    var menuToggle = document.querySelector('.menu-icon');
    var menuText = document.getElementById('menu-text');
    var parent = document.querySelector('.parent');
    var mobileHeaderContent = document.querySelector('.mobile-header-content');
    var pbutton = document.querySelector('.menu-btn12');
    var menuheaderli = document.querySelector('.menu-header-li');
    var menuheaderlispan = document.querySelector('.menu-header-li span');

    parent.classList.toggle('menu-open');

    if (toggleElem.classList.contains('open')) {
        menuToggle.classList.add('close-icon');
        menuText.textContent = 'Close';
        animateBarsClose();
        mobileHeaderContent.style.width = '95%';
        mobileHeaderContent.style.borderRadius = '8px';
        mobileHeaderContent.style.background = '#0004';
        pbutton.style.borderRadius = '8px';
        parent.style.borderRadius = '8px';
        menuheaderli.style.borderRadius = '8px';
        menuheaderli.style.background = '#111111';
        menuheaderlispan.style.color = '#ffffff';
    } else {
        menuToggle.classList.remove('close-icon');
        menuText.textContent = 'Menu';
        animateBarsOpen();
        mobileHeaderContent.style.width = '';
        mobileHeaderContent.style.borderRadius = '';
        mobileHeaderContent.style.background = '#fff2';
        pbutton.style.borderRadius = '';
        parent.style.borderRadius = '';
        menuheaderli.style.borderRadius = '';
        menuheaderli.style.background = '';
        menuheaderlispan.style.color = '';
    }
}

function animateBarsClose() {
    var bars = document.querySelectorAll('.bar');
    bars[0].classList.add('bar-1-close');
    bars[1].classList.add('bar-2-close');
    bars[2].classList.add('bar-3-close');
}

function animateBarsOpen() {
    var bars = document.querySelectorAll('.bar');
    bars[0].classList.remove('bar-1-close');
    bars[1].classList.remove('bar-2-close');
    bars[2].classList.remove('bar-3-close');
}

// Adding event listener to close the menu when clicking on '.blur-bg'
document.querySelector('.blur-bg').addEventListener('click', function() {
    toggleMenu12();
});



document.getElementById("toggle13").addEventListener("click", function() {
    const bgBlur1 = document.querySelector('.blur-bg');
    bgBlur1.classList.toggle('blur-open');
    
    var toggle12 = document.querySelector(".parent");
  var sortaheader = document.querySelector(".sorta_header");
  var mobileHeader = document.querySelector(".mobile-header");
    var mobileHeaderContent = document.querySelector(".mobile-header-content");
    var menuheaderlispan1 = document.querySelector('.menu-header-li span');
  var bgBlur12 = document.querySelector('.blur-bg');

    if (toggle12.style.display !== "none") {
        toggle12.style.display = "none";
        mobileHeaderContent.style.width = "90%";
        mobileHeader.style.top = "1%";
      bgBlur12.style.top = "-1vh";
        menuheaderlispan1.style.display = "none";
      sortaheader.style.display = "none";
    } else {
        toggle12.style.display = "block";
        mobileHeaderContent.style.width = ""; 
        mobileHeader.style.top = "";
       bgBlur12.style.top = "";
        menuheaderlispan1.style.display = "block";
      sortaheader.style.display = "flex";
    }
});





// ---------------------------------menu open-close ------------------------------
function openMenu() {
    const mobileMenu = document.querySelector('.mobile-menu');
    const hamburgerMenu = document.querySelector('.hamburger-menu');
    const openClose = document.querySelector('.nameChangeSpan');
  
    mobileMenu.classList.toggle("mobile-menu-active");
    hamburgerMenu.classList.toggle('open');
  
    if(mobileMenu.classList.contains("mobile-menu-active")){
      // console.log("Close")
      openClose.innerHTML  = "CLOSE";
    }else{
      // console.log("Menu")
      openClose.innerHTML  = "MENU";
    }
  
}
// 

// 

// ------------------accordion----------------


  // -------original code with stop scroll------accordion-----

document.addEventListener("DOMContentLoaded", function () {
    const toggles = document.querySelectorAll(".toggle");
    const boxes = document.querySelectorAll(".box");
    const body = document.body;

    toggles.forEach((toggle) => {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const boxId = this.getAttribute("data-box");
            boxes.forEach((box) => {
                box.classList.remove("open");
            });
            document.getElementById(boxId).classList.add("open");
            body.classList.add("no-scroll"); // Add no-scroll class to body
        });
    });

    const closeBtns = document.querySelectorAll(".close");
    boxes.forEach((closeBtn) => {
        closeBtn.addEventListener("click", function () {
            const parentBox = this.closest(".box");
            parentBox.classList.remove("open");
            body.classList.remove("no-scroll"); // Remove no-scroll class from body
        });
    });

    // Prevent scrolling when a box is open
    window.addEventListener("scroll", function () {
        if (body.classList.contains("no-scroll")) {
            // window.scrollTo(0, 0); 
        }
    });
});







// ------new size-box open close add for close when i reach some point it will close ------------------------

function openSizeBox() {
    const sizeboxMenu = document.querySelector('.size-box');
    
    sizeboxMenu.classList.toggle("size-box-active");

    // Add event listener for scroll
    document.addEventListener('scroll', closeSizeBoxOnScroll);
}

function closeSizeBoxOnScroll() {
    const sizeboxMenu = document.querySelector('.size-box');
    const relatedProducts = document.querySelector('.related-products');

    const sizeboxPosition = sizeboxMenu.getBoundingClientRect();
    const relatedProductsPosition = relatedProducts.getBoundingClientRect();

    if (sizeboxPosition.bottom >= relatedProductsPosition.top) {
        sizeboxMenu.classList.remove("size-box-active");
        document.removeEventListener('scroll', closeSizeBoxOnScroll);
    }
}
